import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import styles from "./GraphPanel.module.scss";


export default function GraphPanel(props) {
  const {
    data, keys,
    dataColor, dataLabel,
    getXAxisLabel = (data) => data.name,
    customElements,
    dataTypes,
    currentDataType,
    setCurrentDataType,
  } = props;

  const renderLineChart = (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={getXAxisLabel} />
        {customElements}
        <YAxis />
        <Tooltip />
        <Legend />
        { keys.map((k) => <Bar key={k} dataKey={k} stackId="a" fill={dataColor(k)} name={dataLabel(k)}/>)}
      </BarChart>
    </ResponsiveContainer>
  );
  return (
    <div className={styles.module}>
      <div className={styles.header}>
        <h3>Filters</h3>
        <DataTypeSelector
          dataTypes={dataTypes}
          currentDataType={currentDataType}
          setCurrentDataType={setCurrentDataType}
        />
      </div>
      <div className={styles.graph}>
        {renderLineChart}
      </div>
    </div>
  );
}


function DataTypeSelector(props) {
  const {
    dataTypes,
    currentDataType,
    setCurrentDataType,
  } = props;

  function handleChange(event) {
    setCurrentDataType(dataTypes[event.target.value]);
  }

  let myType = null;
  let options = Object.keys(dataTypes).map((key) => {
    myType = dataTypes[key];
    return <option key={myType.label} value={key}>{myType.label}</option>
  });

  return (
    <select onChange={handleChange} value={currentDataType.id}>
      {options}
    </select>

  )
}
